let tags = {
  bank_account: 'ACH',
  credit_card: 'CC',
}
export function formatTag(tag) {
  return tags?.[tag] || tag
}
